<template>
  <div class="config-root">

    <!-- Background grid -->
    <div class="bg-grid"></div>

    <div class="config-wrapper">

      <!-- Header -->
      <div class="config-header">
        <div class="header-left">
          <div class="header-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"/>
              <path d="M12 2v2m0 16v2M2 12h2m16 0h2"/>
            </svg>
          </div>
          <div>
            <h1 class="header-title">Configuración de Instancia</h1>
            <p class="header-sub">ID de instancia: <span class="accent-text">#{{ idInstancia }}</span></p>
          </div>
        </div>

        <button class="btn-guardar" @click="guardar" :class="{ saving: isSaving }">
          <span class="btn-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
              <polyline points="17 21 17 13 7 13 7 21"/>
              <polyline points="7 3 7 8 15 8"/>
            </svg>
          </span>
          <span>{{ isSaving ? 'Guardando...' : 'Guardar cambios' }}</span>
        </button>
      </div>

      <!-- Status bar -->
      <div class="status-bar" :class="statusClass">
        <span class="status-dot"></span>
        <span>{{ statusMsg }}</span>
      </div>

      <!-- Sections -->
      <div class="sections-grid">

        <!-- ============== GENERAL (PRINCIPAL) ============== -->
        <section class="config-section">
          <div class="section-label">
            <span class="label-line"></span>
            <span class="label-text">Configuración General</span>
            <span class="label-tag">compartida</span>
          </div>

          <div class="fields-group">

            <div class="field-item field-text">
              <label class="field-label">Nombre de la empresa</label>
              <div class="input-wrapper">
                <svg class="input-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                  <polyline points="9 22 9 12 15 12 15 22"/>
                </svg>
                <input
                  v-model="config.nombreEmpresa"
                  class="custom-input"
                  placeholder="Ej. Industrias CAZEL"
                  type="text"
                />
              </div>
            </div>

            <div class="toggles-row">

              <div class="toggle-card" :class="{ active: config.registroAutomatico }">
                <div class="toggle-info">
                  <div class="toggle-icon-wrap">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="23 4 23 10 17 10"/>
                      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                    </svg>
                  </div>
                  <div>
                    <p class="toggle-name">Registro Automático</p>
                    <p class="toggle-desc">Captura automática de eventos</p>
                  </div>
                </div>
                <button class="toggle-btn" @click="config.registroAutomatico = !config.registroAutomatico">
                  <span class="toggle-track" :class="{ on: config.registroAutomatico }">
                    <span class="toggle-thumb"></span>
                  </span>
                </button>
              </div>

              <div class="toggle-card" :class="{ active: config.registroManual }">
                <div class="toggle-info">
                  <div class="toggle-icon-wrap">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                  </div>
                  <div>
                    <p class="toggle-name">Registro Manual</p>
                    <p class="toggle-desc">Entrada de datos por operador</p>
                  </div>
                </div>
                <button class="toggle-btn" @click="config.registroManual = !config.registroManual">
                  <span class="toggle-track" :class="{ on: config.registroManual }">
                    <span class="toggle-thumb"></span>
                  </span>
                </button>
              </div>

            </div>

            <!-- <v-col cols="12" md="4">
              <v-text-field
                v-model.number="config.pinLength"
                label="Longitud de PIN"
                type="number"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="config.pinType"
                :items="['numbers','alphanumeric']"
                label="Tipo de PIN"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="config.linkTelegram"
                label="Link Telegram"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-switch
                v-model="config.whatsapp"
                label="Notificaciones por WhatsApp"
              />
            </v-col> -->

          </div>
        </section>

        <!-- ============== EJECUTIVO ============== -->
        <section class="config-section">
          <div class="section-label">
            <span class="label-line"></span>
            <span class="label-text">ManagrX Ejecutivo</span>
          </div>

          <!-- <v-row>

            <v-col cols="12" md="4">
              <v-switch
                v-model="config.dashboard"
                label="Dashboard BI"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-switch
                v-model="config.inventario"
                label="Inventarios"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-switch
                v-model="config.reporteAuxiliar"
                label="Reporte Auxiliar"
              />
            </v-col>

          </v-row> -->

        </section>

        <!-- ============== OPS ============== -->
        <section class="config-section">
          <div class="section-label">
            <span class="label-line"></span>
            <span class="label-text">ManagrX Ops</span>
          </div>

          <!-- <v-row>

            <v-col cols="12" md="4">
              <v-switch
                v-model="config.moldes"
                label="Usar Moldes"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-switch
                v-model="config.maquinas"
                label="Usar Máquinas"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-switch
                v-model="config.paros"
                label="Gestión de Paros"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-switch
                v-model="config.oee"
                label="Módulo OEE"
              />
            </v-col>

          </v-row> -->

        </section>

      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {

  data() {
    return {
      idInstancia: 1,
      isSaving: false,
      statusMsg: "Listo",
      statusClass: "status-idle",

      config: {
        nombreEmpresa: "",
        registroAutomatico: false,
        registroManual: false
      }
    };
  },

  created() {
    this.cargar();
  },

  methods: {

    // ================= CARGAR =================
    cargar() {
      this.statusMsg = "Cargando configuración...";
      this.statusClass = "status-loading";

      axios
        .get('/Config?idInstancia=' + this.idInstancia)
        .then(response => {
          this.mapear(response.data);
          this.statusMsg = "Configuración cargada";
          this.statusClass = "status-ok";
          setTimeout(() => {
            this.statusMsg = "Listo";
            this.statusClass = "status-idle";
          }, 2000);
        })
        .catch(err => {
          console.error("Error al cargar configuración:", err);
          this.statusMsg = "Error al cargar";
          this.statusClass = "status-error";
        });
    },

    // ================= MAPEO =================
    mapear(items) {
      Object.keys(this.config).forEach(k => {
        this.config[k] = typeof this.config[k] === 'boolean' ? false : "";
      });
      Object.keys(items).forEach(clave => {
        if (!(clave in this.config)) return;
        this.config[clave] = items[clave];
      });
    },

    // ================= GUARDAR =================
    guardar() {
      this.isSaving = true;
      this.statusMsg = "Guardando...";
      this.statusClass = "status-loading";

      const payload = Object.keys(this.config).map(k => ({
        clave: k,
        valor: String(this.config[k])
      }));

      axios
        .post('/Config/Post/' + this.idInstancia, payload)
        .then(() => {
          this.statusMsg = "Guardado correctamente";
          this.statusClass = "status-ok";
          this.cargar();
        })
        .catch(err => {
          console.error("Error al guardar configuración:", err);
          this.statusMsg = "Error al guardar";
          this.statusClass = "status-error";
        })
        .finally(() => {
          this.isSaving = false;
          setTimeout(() => {
            this.statusMsg = "Listo";
            this.statusClass = "status-idle";
          }, 3000);
        });
    }

  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&family=Sora:wght@300;400;500;600;700&display=swap');

/* ---- RESET & ROOT ---- */
* { box-sizing: border-box; margin: 0; padding: 0; }

.config-root {
  min-height: 100vh;
  background: #f4f6f9;
  font-family: 'Sora', sans-serif;
  color: #1e293b;
  position: relative;
  overflow: hidden;
}

/* Background grid */
.bg-grid {
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(0,0,0,.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0,0,0,.04) 1px, transparent 1px);
  background-size: 40px 40px;
  pointer-events: none;
  z-index: 0;
}

.config-wrapper {
  position: relative;
  z-index: 1;
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 24px 80px;
}

/* ---- HEADER ---- */
.config-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 16px;
  flex-wrap: wrap;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-icon {
  width: 44px;
  height: 44px;
  background: #fff;
  border: 1px solid #dde3ed;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2563eb;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,.06);
}

.header-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.header-sub {
  font-size: 0.72rem;
  color: #94a3b8;
  font-family: 'JetBrains Mono', monospace;
  margin-top: 2px;
}

.accent-text {
  color: #2563eb;
}

/* ---- SAVE BUTTON ---- */
.btn-guardar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-family: 'Sora', sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.01em;
  box-shadow: 0 2px 8px rgba(37,99,235,.3);
}

.btn-guardar:hover {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  box-shadow: 0 4px 16px rgba(37,99,235,.35);
  transform: translateY(-1px);
}

.btn-guardar.saving {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.btn-icon {
  display: flex;
  align-items: center;
}

/* ---- STATUS BAR ---- */
.status-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-family: 'JetBrains Mono', monospace;
  margin-bottom: 32px;
  border: 1px solid transparent;
  transition: all 0.3s ease;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-idle {
  background: rgba(0,0,0,.02);
  border-color: #e2e8f0;
  color: #94a3b8;
}
.status-idle .status-dot { background: #cbd5e0; }

.status-loading {
  background: rgba(234,179,8,.06);
  border-color: rgba(234,179,8,.3);
  color: #b45309;
}
.status-loading .status-dot {
  background: #eab308;
  animation: pulse 1s infinite;
}

.status-ok {
  background: rgba(34,197,94,.06);
  border-color: rgba(34,197,94,.3);
  color: #15803d;
}
.status-ok .status-dot { background: #22c55e; }

.status-error {
  background: rgba(239,68,68,.06);
  border-color: rgba(239,68,68,.3);
  color: #b91c1c;
}
.status-error .status-dot { background: #ef4444; }

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* ---- SECTIONS GRID ---- */
.sections-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ---- CONFIG SECTION ---- */
.config-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 28px;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 6px rgba(0,0,0,.04);
}

.config-section:hover {
  border-color: #bfdbfe;
  box-shadow: 0 2px 12px rgba(37,99,235,.07);
}

/* ---- SECTION LABEL ---- */
.section-label {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.label-line {
  width: 3px;
  height: 18px;
  background: linear-gradient(180deg, #60a5fa, #2563eb);
  border-radius: 4px;
  flex-shrink: 0;
}

.label-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: 0.01em;
}

.label-tag {
  font-size: 0.65rem;
  font-family: 'JetBrains Mono', monospace;
  padding: 2px 8px;
  border-radius: 20px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #2563eb;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

/* ---- FIELDS ---- */
.fields-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.field-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 500;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 8px;
  font-family: 'JetBrains Mono', monospace;
}

/* Text input */
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 13px;
  color: #94a3b8;
  pointer-events: none;
}

.custom-input {
  width: 100%;
  padding: 11px 14px 11px 36px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #1e293b;
  font-family: 'Sora', sans-serif;
  font-size: 0.875rem;
  outline: none;
  transition: all 0.2s;
}

.custom-input::placeholder { color: #cbd5e0; }

.custom-input:focus {
  border-color: #93c5fd;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(37,99,235,.08);
}

/* ---- TOGGLES ---- */
.toggles-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

@media (max-width: 600px) {
  .toggles-row { grid-template-columns: 1fr; }
}

.toggle-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: all 0.2s;
  gap: 12px;
}

.toggle-card.active {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.toggle-info {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.toggle-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  flex-shrink: 0;
  transition: all 0.2s;
}

.toggle-card.active .toggle-icon-wrap {
  background: #dbeafe;
  border-color: #bfdbfe;
  color: #2563eb;
}

.toggle-name {
  font-size: 0.82rem;
  font-weight: 500;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toggle-desc {
  font-size: 0.68rem;
  color: #94a3b8;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---- TOGGLE SWITCH ---- */
.toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}

.toggle-track {
  display: block;
  width: 40px;
  height: 22px;
  background: #e2e8f0;
  border: 1px solid #cbd5e0;
  border-radius: 20px;
  position: relative;
  transition: all 0.25s ease;
}

.toggle-track.on {
  background: #2563eb;
  border-color: #2563eb;
  box-shadow: 0 2px 8px rgba(37,99,235,.35);
}

.toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  transition: all 0.25s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,.15);
}

.toggle-track.on .toggle-thumb {
  transform: translateX(18px);
}
</style>